import { memo, useCallback, useEffect } from "react";
import { type IUser } from "src/components/shared/UserList/UserList.types";
import AuthorizationModal from "src/generator/_Modals/AuthorizationModal/AuthorizationModal";
import { mapUsers } from "src/generator/utils/mapUsers";
import { refreshLogoutTimer } from "src/generator/utils/refreshLogoutTimer";
import { useGetApi, usePostApi } from "src/hooks";
import { type ICredentials } from "src/interfaces";
import { getUserId, getYachtId } from "src/utils";

interface Props {
  opened: boolean;
  close: () => void;
  voluntary?: boolean;
}

const mapper = (data: { data?: IUser[] }) => {
  if (data?.data && Array.isArray(data.data)) {
    return mapUsers(data.data, "", "role firstname surname");
  }
  return [];
};

const LogoutModal = ({ opened, close, voluntary }: Props) => {
  const { post, isLoading } = usePostApi();

  const { data: users, refetch: fetchUsers } = useGetApi({
    request: "re-auth-users",
    body: { params: { userid: getUserId(), yachtid: getYachtId() } },
    fetchOnInit: false,
    mapper,
  });

  useEffect(() => {
    if (opened) {
      void fetchUsers();
    }
  }, [opened, fetchUsers]);

  const handleSubmit = useCallback(
    async ({ pass, userid }: ICredentials) => {
      await post({
        request: "re-auth",
        body: { params: { pass, userid } },
        onSuccess: () => {
          close();
          refreshLogoutTimer();
        },
      });
    },
    [close, post],
  );

  return (
    <AuthorizationModal
      opened={!!(opened && users)}
      close={close}
      users={users ?? []}
      onSubmit={handleSubmit}
      loading={isLoading}
      logout
      dismissible={voluntary}
      title={voluntary ? "Reset logout timer" : undefined}
    />
  );
};

export default memo(LogoutModal);
